// Dashboard filters APIs for Project Development
// Replace mock implementations with real axios calls when backend is ready.

import axios from 'axios';
import { appUrl } from '../../../../../../utils/config';

// Build API base URL from localStorage
const getApiBaseUrl = () => {
  const appName = localStorage.getItem("appName");
  const network = localStorage.getItem("network");
  const collabType = localStorage.getItem("collabType");
  const roleName = localStorage.getItem("roleName");

  if (appName && network && collabType && roleName) {
    return `${appUrl}/${appName}/${network}/${collabType}/${roleName}`;
  }
  return null;
};

// ===== API FUNCTIONS =====

export const fetchCMOSitesAPI = async () => ({
  status: true,
  data: ['Patheon'],
  displayData: ['Patheon'],
});

export const fetchMfgPlantsAPI = async () => ({
  status: true,
  data: ['Greenville, NC, USA', 'Cincinnati, OH, USA', 'Durham, NC, USA'],
});

export const fetchBrandsAPI = async () => ({
  status: true,
  data: ['Multiple Selection', 'Brand A', 'Brand B'],
});

export const fetchDeliverableTypesAPI = async () => ({
  status: true,
  data: [
    { deliverableTypeID: 1, deliverableTypeName: 'Bulk Drug Product', activated: true },
    { deliverableTypeID: 2, deliverableTypeName: 'Drug Product', activated: true },
    { deliverableTypeID: 3, deliverableTypeName: 'Drug Substance', activated: true },
  ],
  displayData: ['Bulk Drug Product', 'Drug Product', 'Drug Substance'],
});

// Fetch data granularity levels for Add New Project
export const fetchDataGranularityLevelsAPI = async () => {
  try {
    const apiBaseUrl = getApiBaseUrl();
    if (!apiBaseUrl) {
      return {
        status: false,
        data: [],
      };
    }

    // Append /true as required by backend (e.g., for projectConfig context)
    const response = await axios.get(`${apiBaseUrl}/fetchDataGranularityLevels/true`);

    if (response?.data?.status === true || response?.data?.status === "true") {
      const levels = response?.data?.data?.dataGranularityLevels || [];

      // Only keep activated levels
      const activatedLevels = levels.filter(level => level.activated === true);

      return {
        status: true,
        data: activatedLevels, // full objects with IDs
        displayData: activatedLevels.map(level => level.dataGranularityLevelName),
      };
    }

    return {
      status: false,
      data: [],
    };
  } catch (error) {
    return {
      status: false,
      data: [],
    };
  }
};

export const fetchAllFiltersAPI = async () => {
  // Real API (to enable later):
  // const response = await axios.get(`${apiBaseUrl}/filters`);
  // return response.data;

  // Shape matches useProductDevelopment expectations: { status, save_filter_options: { cmoSite, deliverableType } }
  return {
    status: true,
    save_filter_options: {
      cmoSite: 'all',
      deliverableType: 'all',
    },
  };
};

export const saveFiltersAPI = async (filters = {}) => {
  console.log('[Dashboard] Saving filters (mock):', filters);

  // Real API (to enable later):
  // const response = await axios.post(`${apiBaseUrl}/filters/save`, filters);
  // return response.data;

  return {
    status: true,
    message: 'Filters saved successfully (mock)',
  };
};


